import { render, staticRenderFns } from "./SingleConsignmentOrdersModal.vue?vue&type=template&id=66b1ef9f&"
import script from "./SingleConsignmentOrdersModal.vue?vue&type=script&lang=js&"
export * from "./SingleConsignmentOrdersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SingleConsignmentOrdersModal.vue"
export default component.exports